import React from 'react';
import { LayoutDashboard, CalendarDays, UserCheck, ClipboardEdit, Wallet, BarChart3, Settings } from 'lucide-react';
export type PageType = 'dashboard' | 'roster' | 'attendance' | 'manual' | 'payroll' | 'reports' | 'settings';
interface AppSidebarProps {
  activePage: PageType;
  onNavigate: (page: PageType) => void;
}
export function AppSidebar({
  activePage,
  onNavigate
}: AppSidebarProps) {
  const navItems = [{
    id: 'dashboard',
    label: 'Dashboard',
    icon: LayoutDashboard
  }, {
    id: 'roster',
    label: 'Roster',
    icon: CalendarDays
  }, {
    id: 'attendance',
    label: 'Attendance',
    icon: UserCheck
  }, {
    id: 'manual',
    label: 'Manual Attendance',
    icon: ClipboardEdit
  }, {
    id: 'payroll',
    label: 'Payroll',
    icon: Wallet
  }, {
    id: 'reports',
    label: 'Reports',
    icon: BarChart3
  }, {
    id: 'settings',
    label: 'Settings',
    icon: Settings
  }] as const;
  return <aside className="w-64 bg-slate-900 text-white flex-shrink-0 flex flex-col h-screen overflow-y-auto scrollbar-custom" data-id="element-181">
      <div className="p-6" data-id="element-182">
        <h1 className="text-2xl font-bold tracking-tight text-white flex items-center gap-2" data-id="element-183">
          <div className="w-8 h-8 bg-indigo-500 rounded-lg flex items-center justify-center" data-id="element-184">
            <span className="text-white font-bold text-lg leading-none" data-id="element-185">
              HR
            </span>
          </div>
          ERPHRPark
        </h1>
        <p className="text-slate-400 text-xs mt-1 ml-10" data-id="element-186">
          HR & Attendance Portal
        </p>
      </div>

      <nav className="flex-1 px-4 space-y-1" data-id="element-187">
        {navItems.map(item => {
        const Icon = item.icon;
        const isActive = activePage === item.id;
        return <button key={item.id} onClick={() => onNavigate(item.id)} className={`w-full flex items-center gap-3 px-4 py-3 rounded-lg text-sm font-medium transition-all duration-200 ${isActive ? 'bg-white/10 text-white border-l-4 border-indigo-400' : 'text-slate-400 hover:bg-white/5 hover:text-white border-l-4 border-transparent'}`} data-id="element-188">
              <Icon size={20} className={isActive ? 'text-indigo-400' : 'text-slate-400'} data-id="element-189" />
              {item.label}
            </button>;
      })}
      </nav>

      <div className="p-4 border-t border-slate-800" data-id="element-190">
        <div className="flex items-center gap-3 px-4 py-2" data-id="element-191">
          <div className="w-8 h-8 rounded-full bg-slate-700 flex items-center justify-center" data-id="element-192">
            <span className="text-sm font-medium text-white" data-id="element-193">AD</span>
          </div>
          <div className="text-left" data-id="element-194">
            <p className="text-sm font-medium text-white" data-id="element-195">Admin User</p>
            <p className="text-xs text-slate-400" data-id="element-196">admin@attendease.com</p>
          </div>
        </div>
      </div>
    </aside>;
}